var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveDemoLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 346,
    viewBox: "0 0 69 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40918 339.376C30.4708 311.389 73.5215 232.623 37.2312 141.451C20.8831 96.7391 -0.629861 1.8807 44.1025 -19.8602",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.58135 339.94C25.7152 311.969 69.1316 233.228 32.4246 142.027C15.8862 97.302 -5.90197 2.42421 39.2518 -19.287",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.12207 338.246C20.9395 310.259 63.9902 231.492 27.6999 140.32C11.3519 95.6087 -10.1611 0.750328 34.5713 -20.9906",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.0189 337.442C16.2777 309.472 59.6941 230.731 22.9871 139.53C6.44873 94.8049 -15.3395 -0.0728619 29.8143 -21.784",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.751 338.482C11.3106 310.495 54.3613 231.728 18.071 140.556C1.72299 95.8445 -19.79 0.986167 24.9423 -20.7548",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.2705 337.705C6.79111 309.718 49.8418 230.951 13.5515 139.779C-2.79654 95.0677 -24.3095 0.209312 20.4228 -21.5316",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.8604 337.839C2.20126 309.852 45.2519 231.085 8.96167 139.913C-7.38638 95.2015 -28.8994 0.343101 15.833 -21.3978",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.4131 337.517C-2.35147 309.53 40.6992 230.763 4.40893 139.591C-11.9391 94.8797 -33.4521 0.0213236 11.2802 -21.7196",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.9678 337.195C-6.90616 309.209 36.1445 230.442 -0.145753 139.27C-16.4938 94.5584 -38.0068 -0.299965 6.72555 -22.0409",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.2549 339.248C-12.1933 311.261 30.8574 232.494 -5.43286 141.322C-21.7809 96.6107 -43.2939 1.75228 1.43844 -19.9887",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.2454 339.811C-16.9488 311.84 26.4676 233.1 -10.2395 141.898C-26.7778 97.1731 -48.566 2.2953 -3.41226 -19.4159",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.7842 338.117C-21.7226 310.131 21.3281 231.364 -14.9622 140.192C-31.3102 95.4803 -52.8232 0.62191 -8.09086 -21.119",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.6829 337.314C-26.3863 309.344 17.0301 230.603 -19.677 139.402C-36.2153 94.6765 -58.0035 -0.20128 -12.8498 -21.9125",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.4131 338.353C-31.3515 310.366 11.6992 231.6 -24.5911 140.428C-40.9391 95.7161 -62.4521 0.857749 -17.7198 -20.8832",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.9365 337.576C-35.8749 309.589 7.17575 230.822 -29.1145 139.65C-45.4626 94.9388 -66.9756 0.0804057 -22.2432 -21.6605",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.5225 337.71C-40.4608 309.723 2.58982 230.957 -33.7004 139.785C-50.0485 95.0731 -71.5615 0.214683 -26.8291 -21.5262",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.0771 337.388C-45.0155 309.402 -1.96487 230.635 -38.2551 139.463C-54.6032 94.7513 -76.1162 -0.107094 -31.3838 -21.848",
    stroke: "white",
    strokeWidth: 0.456561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.6299 337.067C-49.5683 309.08 -6.51761 230.314 -42.8079 139.142C-59.1559 94.43 -80.6689 -0.428383 -35.9366 -22.1693",
    stroke: "white",
    strokeWidth: 0.456561
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDemoLines);
export default __webpack_public_path__ + "static/media/liveDemoLines.6611b4e69082a2b1a137593b8c4fe138.svg";
export { ForwardRef as ReactComponent };